import Vue from 'vue'

const domUtil = {
  /**
   * 使Dom元素全屏
   * @param {Object|String} domObject 
   */
  fullscreen (domObject) {
    typeof domObject === 'string' && (domObject = this.selector(domObject))
    if (domObject) {
      if (domObject.requestFullscreen) {
        return domObject.requestFullscreen()
      } else if (domObject.webkitRequestFullScreen) {
        return domObject.webkitRequestFullScreen()
      } else if (domObject.mozRequestFullScreen) {
        return domObject.mozRequestFullScreen()
      } else {
        return domObject.msRequestFullscreen()
      }
    }
  },

  /**
   * 滚动元素至指定像素
   * @param {Object|String} domObject top|middle|bottom|(+/-)x
   * @param {String|Number} position
   */
  scrollTop (domObject, position) {
    typeof domObject === 'string' && (domObject = this.selector(domObject))
    if (domObject) {
      if (typeof position === 'string') {
        if (position === 'top') {
          domObject.scrollTop = 0
        } else if (position === 'bottom') {
          domObject.scrollTop = domObject.scrollHeight
        } else if (position === 'middle') {
          domObject.scrollTop = (domObject.scrollHeight - domObject.clientHeight) / 2
        } else if (/^(\+|-)?\d+(\.\d+)?(px)?$/.test(position)) {
          position = position.replace('px', '')
          if (/^(\+|-)\d+(\.\d+)?$/.test(position)) {
            const symbol = position.slice(0, 1)
            position = Number(position.slice(1))
            if (!isNaN(position)) {
              symbol === '+' ? (domObject.scrollTop += position) : (domObject.scrollTop  -= position)
            }
          } else {
            if (!isNaN(position)) {
              domObject.scrollTop = position
            }
          }
        } else if (/^(\+|-)?\d+(\.\d+)?%{1}$/.test(position)) {
          position = position.replace('%', '')
          if (/^(\+|-)\d+(\.\d+)?$/.test(position)) {
            const symbol = position.slice(0, 1)
            position = Number(position.slice(1))
            if (!isNaN(position)) {
              symbol === '+' ? (domObject.scrollTop += (domObject.scrollHeight - domObject.clientHeight) * position / 100) : (domObject.scrollTop -= (domObject.scrollHeight - domObject.clientHeight) * position / 100)
            }
          } else {
            if (!isNaN(position)) {
              domObject.scrollTop = (domObject.scrollHeight - domObject.clientHeight) * position / 100
            }
          }
        }
      } else if (typeof position === 'number') {
        domObject.scrollTop = position
      }
    }
  },

  /**
   * 获取document里面的第一个元素
   * @param {String} domString 
   */
  selector (domString) {
    if (typeof domString === 'string') {
      return document.querySelector(domString)
    } else {
      return undefined
    }
  }
}

Vue.prototype.$dom = domUtil
